import React, {Component, useEffect, useState} from 'react';
import {connect} from 'react-redux';
import JSONViewer from './JSONViewer';
import {getAppConfiguration, getConfiguration} from "../../../requests/ConfigRequests";
import {setConfig as setAppConfig} from "../../../reducers/AppReducer";

export function CustomizingPage() {
    const [data, setData] = useState({});
    useEffect(() => {
        getAppConfiguration().then(_ => setData(_?.sap?.data));
    }, []);

    return (
        <div>
            {/* <ReactJson src={data} theme="rjv-default" iconStyle="triangle" enableClipboard="false" /> */}
            <JSONViewer json={data}></JSONViewer>
        </div>
    );
}

export default connect<any, any, any, any>((store) => ({
    sapDetails: store.app.config.sap?.data,
}))(CustomizingPage);